import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { Table } from "../../s25-table/Table";
import { EventReservation, ReservationService } from "../../../services/reservation.service";
import { S25TableComponent } from "../../s25-table/s25.table.component";
import { Bind } from "../../../decorators/bind.decorator";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25RadioComponent } from "../../s25-radio/s25.radio.component";

@TypeManagerDecorator("s25-ng-document-reservation-list")
@Component({
    selector: "s25-ng-document-reservation-list",
    template: ` <s25-ng-table [dataSource]="tableConfig" [columnSortable]="true"></s25-ng-table> `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25DocumentReservationListComponent implements OnInit, OnChanges {
    @Input({ required: true }) eventId: number;

    @Input() onSelect: (reservationId: number) => void;
    @Output() selected = new EventEmitter<number>();

    @ViewChild(S25TableComponent) tableComponent: S25TableComponent;

    tableConfig: Table.DataSource;

    constructor(private changeDetector: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.eventId) this.tableComponent?.refresh();
    }

    ngOnInit() {
        this.initTableConfig();
        this.changeDetector.detectChanges();
    }

    initTableConfig() {
        this.tableConfig = {
            type: "unpaginated",
            dataSource: this.getRows,
            columns: [
                {
                    id: "select",
                    header: "",
                    width: "min-content",
                    sortable: false,
                },
                {
                    id: "date",
                    header: "Date",
                },
                {
                    id: "state",
                    header: "State",
                    width: 100,
                },
                {
                    id: "locations",
                    header: "Locations",
                },
                {
                    id: "resources",
                    header: "Resources",
                },
            ],
        };
    }

    @Bind
    async getRows(): Promise<Table.DataSourceResponse> {
        const reservations = await ReservationService.getEventReservations(this.eventId);

        return {
            rows: reservations.map(this.mapToRow),
        };
    }

    @Bind
    mapToRow(reservation: EventReservation): Table.Row {
        return {
            id: reservation.reservation_id,
            name: reservation.dateTime,
            cells: {
                date: { text: reservation.dateTime },
                state: { text: reservation.stateName },
                locations: { text: reservation.locations },
                resources: { text: reservation.resources },
                select: {
                    component: S25RadioComponent,
                    inputs: {
                        name: "select-document-reservation",
                        radioValue: reservation.reservation_id,
                    },
                    outputs: {
                        valueChange: (value, context) => this.selectOccurrence(context.row),
                    },
                } satisfies Table.Cell<S25RadioComponent<number>>,
            },
        };
    }

    @Bind
    async selectOccurrence(row: Table.Row) {
        this.selected.emit(row.id as number);
        this.onSelect?.(row.id as number);
    }
}
